import { render, staticRenderFns } from "./page.vue?vue&type=template&id=0dc6a57c&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=0dc6a57c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6a57c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc6a57c')) {
      api.createRecord('0dc6a57c', component.options)
    } else {
      api.reload('0dc6a57c', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=0dc6a57c&scoped=true&", function () {
      api.rerender('0dc6a57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blindOpen/page.vue"
export default component.exports